// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
/**
 * The following are shared across all platforms and apps
 */
.font-color {
  color: var(--undp-jtf-btn-dark-color);
}

.heading-section {
  color: var(--undp-jtf-btn-dark-color);
  padding: 2rem 3rem 0 0;
  border-bottom: 2px solid #e8e8e8;
}
.heading-section .heading {
  font: normal normal bold 24px/32px "OpenSans-Regular";
}

.error {
  color: red;
}
.error p {
  margin-top: 5px;
}

.contact-us-body-container {
  background-color: #fff;
  border-radius: 20px;
  color: var(--undp-jtf-btn-dark-color);
  padding: 4rem 3rem 4rem 3rem;
  font-family: "OpenSans-Regular";
  margin-bottom: 4rem;
}
.contact-us-body-container .section {
  padding-bottom: 2rem;
}
.contact-us-body-container .section .form-group {
  margin-top: 1rem;
}
.contact-us-body-container .section .form-group label {
  color: var(--undp-jtf-btn-dark-color);
  font-size: 1rem;
  font-weight: bold;
}
.contact-us-body-container .section .form-group .form-control {
  border: 1px solid #707070;
}
.contact-us-body-container .btn-lg-blue {
  margin-top: 1rem;
  color: #fff;
  background-color: var(--undp-jtf-btn-dark-color);
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/contact-us/components/contact-us.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;AAAA;;EAAA;ACGA;EACE,qCAAA;AAIF;;AAFA;EACE,qCAAA;EACA,sBAAA;EACA,gCAAA;AAKF;AAJE;EACE,qDAAA;AAMJ;;AAFA;EACE,UAAA;AAKF;AAJE;EACE,eAAA;AAMJ;;AAFA;EACE,sBAAA;EACA,mBAAA;EACA,qCAAA;EACA,4BAAA;EACA,+BCtBqB;EDuBrB,mBAAA;AAKF;AAJE;EACE,oBAAA;AAMJ;AALI;EACE,gBAAA;AAON;AANM;EACE,qCAAA;EACA,eAAA;EACA,iBAAA;AAQR;AANM;EACE,yBAAA;AAQR;AAJE;EACE,gBAAA;EACA,WAAA;EACA,gDAAA;EACA,eAAA;AAMJ","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '@eview/scss/index';\n@import '../../../../scss/variables';\n\n.font-color {\n  color: var(--undp-jtf-btn-dark-color);\n}\n.heading-section {\n  color: var(--undp-jtf-btn-dark-color);\n  padding: 2rem 3rem 0 0;\n  border-bottom: 2px solid #e8e8e8;\n  .heading {\n    font: normal normal bold 24px/32px $primary-font-regular;\n  }\n}\n\n.error {\n  color: red;\n  p {\n    margin-top: 5px;\n  }\n}\n\n.contact-us-body-container {\n  background-color: #fff;\n  border-radius: 20px;\n  color: var(--undp-jtf-btn-dark-color);\n  padding: 4rem 3rem 4rem 3rem;\n  font-family: $primary-font-regular;\n  margin-bottom: 4rem;\n  .section {\n    padding-bottom: 2rem;\n    .form-group {\n      margin-top: 1rem;\n      label {\n        color: var(--undp-jtf-btn-dark-color);\n        font-size: 1rem;\n        font-weight: bold;\n      }\n      .form-control {\n        border: 1px solid #707070;\n      }\n    }\n  }\n  .btn-lg-blue {\n    margin-top: 1rem;\n    color: #fff;\n    background-color: var(--undp-jtf-btn-dark-color);\n    font-size: 1rem;\n  }\n}\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
